import { useState } from 'react'
import CustomInput from '../../../../components/common/Input/input'
import { useNavigate, useParams } from 'react-router-dom'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import Swal from 'sweetalert2'
import * as api from '../../../../api/outrasPaginas'
import { Box, Button, Flex, FormControl, FormLabel, Heading, Radio, RadioGroup } from '@chakra-ui/react';
import { Carousel } from '../../../../components/Carousel/carousel';
import { templates } from '../../../../components/TemplatePaginas/template-pagina';

interface Template {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
  preview: string;
}

function InserirPagina() {
  const navigate = useNavigate()
  const [txtHtml, setTxtHtml] = useState('');
  const [siteExterno, setSiteExterno] = useState('1');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);

  const [formValues, setFormValues] = useState({
    nomPagina: {
      value: '',
      error: false
    },
    dscUrl: {
      value: '',
      error: false
    },
    txtHtml: {
      value: '',
      error: false
    }
  })

  const isFormValid = () => {
    const { nomPagina } = formValues;
    return (
      nomPagina.value.trim() &&
      formValues.dscUrl.value.trim() &&
      nomPagina.value.length >= 5
    )
  };

  const handleFieldChange = (field: string, value: string) =>
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    })

  const nextTemplate = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === templates.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTemplate = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? templates.length - 1 : prevIndex - 1
    );
  };

  const handleTemplateSelect = (templateId: any, index: any) => {
    setSelectedTemplate(templateId);
    setCurrentIndex(index);
  };

  const formataData = (date: any) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const handleSubmit = async () => {
    const { nomPagina } = formValues;
    const { dscUrl } = formValues;

    const params = {
      nomPagina: nomPagina.value || null,
      dscUrl: dscUrl.value || null,
      datRegistro: formataData(new Date()),
      txtHtml: null,
      numHtmlProprio: 1,
      numBloqueada: 0,
      sitRegistro: 1,
      datInativo: null,
      codModeloPagina: null,
      jsonModelo: null
    };

    try {
      await api.inserirPagina(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Página inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    } catch (error) {
      console.error('Erro ao inserir página:', error);
    
      if (typeof error === 'string' && error.includes('Erro ao atualizar a Pagina')) {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'O nome da página já está em uso. Por favor, escolha outro.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',    
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'Erro ao inserir página. Tente novamente mais tarde.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      }
    }    
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Incluir Página
      </Heading>
      <div className="row mb-3">
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Nome da Página</FormLabel>
            <CustomInput
              placeholder='Digite um nome'
              value={formValues.nomPagina.value}
              onChange={(e) => handleFieldChange('nomPagina', e.target.value)}
              maxLength={100}
            />
          </FormControl>
        </div>
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">URL da Página</FormLabel>
            <CustomInput
              placeholder='Digite uma URL'
              value={formValues.dscUrl.value}
              onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
              maxLength={512}
            />
          </FormControl>
        </div>
        <div className="col-md-6 mb-4">
          <FormControl>
            <FormLabel mb="8px">Site externo</FormLabel>
            <RadioGroup
              mt={3.5}
              value={siteExterno}
              onChange={(value) => setSiteExterno(value)}
            >
              <Radio value="1" mr={5}>Sim</Radio>
              <Radio value="0">Não</Radio>
            </RadioGroup>
          </FormControl>
        </div>
        {siteExterno === '0' && (
          <div className="col-md-12 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Escolha um modelo pré-definido</FormLabel>
              <Carousel items={templates} />
            </FormControl>
          </div>
        )}
      </div>

      <Box alignItems={'flex-end'}>
        <Button type="submit" m="px" onClick={() =>        
          navigate('/cms/edicao-cidade-inteligente/outras-paginas')
          }>
          Desistir
        </Button>
        <Button
          type="submit"
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={() => {
            handleSubmit();
          }}
          isDisabled={!isFormValid()}
        >
          Inserir Página
        </Button>
      </Box>
    </Flex>
  )
}

export default InserirPagina;
